import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '@constants/endpoints.constants';
import { DaysOff } from '@common/models/days-off.model';
import { BookedDates } from '@common/models/booked-dates.model';

@Injectable({
    providedIn: 'root',
})
export class ScheduleService {
    constructor(private router: Router, private route: ActivatedRoute, private http: HttpClient) {}

    getDaysOff(locationCode: number | null | undefined) {
        return this.http.get<any>(
            `${API_BASE_URL}/calendar/${locationCode}`
        );
    }

    getBookedDates(locationCode: number | null | undefined, cost: string | null | undefined) {
        return this.http.get<BookedDates>(
            `${API_BASE_URL}/availabilities/${locationCode}?cost=${cost}`
        );
    }
}
